import { Action, any, IOWidget } from 'widgets-for-react'
import { BlocksRenderer, getMockedBlockRenderer, renderBlock } from '../../cms/blocks/block_to_widget.gen'
import { TemplateState } from '../../cms/page/types.gen'
import { CustomBlock } from '../../wordpress/types_and_parser/bsl_blocks.gen'
import { Block } from '../../wordpress/types_and_parser/standard_blocks.gen'
import { PublicSite_CustomPageData } from '../application.mod'
import { ExtraImages } from '../utils/extra_images.mod'
import { CustomBlockData, isCustomBlockData, renderCustomBlock } from './custom_blocks/types.mod'


export let blocks_renderer = <customBlockData, extra_images>() => ({
  ...getMockedBlockRenderer<customBlockData, extra_images>()
  // featuredContentComponent:myFeauredContentBlock
})

export function pageDisplay_AUX(
  blocks: Array<Block | CustomBlock>,
  blocks_renderer: BlocksRenderer<CustomBlockData, ExtraImages>
): IOWidget<
  TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>,
  Action<TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>>
> {
  return s =>
    any<Action<TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>>>()([
      ...s.blocks
        .map((b, index) => {
          return isCustomBlockData(b)
            ? renderCustomBlock(
                b,
                `key-${index}`
              )(s).map<
                Action<TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>>
              >(a => s1 => {
                let res = a(s1)
                return { ...s1, images: res.images, blocks: res.blocks }
              })
            : renderBlock(
                b,
                blocks_renderer,
                `key-${index}`
              )(s).map<
                Action<TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>>
              >(a => s1 => {
                let res = a(s1)
                return { ...s1, images: res.images, blocks: res.blocks }
              })
        })
        .valueSeq()
        .toArray()
    ])
}
export let pageDisplay = (
  blocks_renderer: BlocksRenderer<CustomBlockData, ExtraImages>
): ((
  b: Array<Block | CustomBlock>
) => IOWidget<
  TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>,
  Action<TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>>
>) => b => pageDisplay_AUX(b, blocks_renderer)
